import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-brand-dark text-white text-center relative overflow-hidden" data-id="element-71">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&q=80&w=2000')] opacity-10 bg-cover bg-center mix-blend-luminosity" data-id="element-72"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/90 to-brand-dark/80" data-id="element-73"></div>

      <div className="container mx-auto px-6 relative z-10 max-w-3xl" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-75">
          <h2 className="font-serif text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-76">
            Empieza hoy a tomar{' '}
            <span className="text-brand-gold" data-id="element-77">
              decisiones financieras más inteligentes
            </span>
          </h2>
          <p className="text-gray-300 text-lg mb-10 max-w-xl mx-auto" data-id="element-78">
            No esperes a que tu crédito se arregle solo. Toma acción con un
            sistema diseñado para darte resultados.
          </p>

          <motion.button onClick={scrollToOffer} className="px-10 py-5 bg-brand-gold hover:bg-brand-goldHover text-brand-dark rounded-xl font-bold text-xl transition-all shadow-gold hover:shadow-xl hover:-translate-y-1 inline-flex items-center gap-3" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-79">
            QUIERO ACCESO INMEDIATO
            <ArrowRight className="w-6 h-6" data-id="element-80" />
          </motion.button>

          <div className="flex flex-wrap justify-center gap-6 mt-8 text-sm text-gray-400" data-id="element-81">
            <span data-id="element-82">✦ Acceso 100% digital</span>
            <span data-id="element-83">✦ Aprende a tu ritmo</span>
            <span data-id="element-84">✦ Aplicación inmediata</span>
          </div>
        </motion.div>
      </div>
    </section>;
}